<div class="accordion" aria-label="Accordion">
  <input
    type="checkbox"
    #input
    (click)="accordionClick(input.checked)"
    id="{{ id }}"
    [checked]="isOpen"
    [attr.aria-label]="'Accordion is ' + (isOpen ? 'open' : 'closed') + ' … … '" />
  <label class="caret" for="{{ id }}">
    <ng-content select="[acc-open]"></ng-content>
    <svg-icon
      src="/assets/icons/chevron-left-nocircle.svg"
      class="caret-arrow"
      [ngClass]="{ 'is-animating': isAnimating }"
      [attr.aria-label]="'… Click to ' + (isOpen ? 'close' : 'open') + ' accordion … '"
      (click)="accordionClick(input.checked)"></svg-icon>
  </label>
  <div class="body" aria-label="Accordion content … " #collapsibleBody>
    <ng-content select="[acc-collapsible]"></ng-content>
  </div>
</div>
